import React from 'react';
import PropTypes from 'prop-types';
import hljs from 'highlight.js';

class CodeHighlight extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired
  }

  componentDidMount() {
    this.highlightCode();
  }

  componentDidUpdate() {
    this.highlightCode();
  }

  highlightCode() {
    const nodes = this.element.querySelectorAll('pre code');

    for (let i = 0; i < nodes.length; i += 1) {
      hljs.highlightBlock(nodes[i]);
    }
  }

  render() {
    return (
      <div ref={(e) => { this.element = e; }}>
        {this.props.children}
      </div>
    );
  }
}

export default CodeHighlight;
